import Vue from 'vue';
import EKDialog from './EvtRule.vue'

let DialogConstructor = Vue.extend(EKDialog) // 构造函数
let instance // 实例对象

const Evt_rule_Dialog = (options = {}) => {
  instance = new DialogConstructor({
    data: options
  })
  
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.visible = true
  instance.dom = instance.vm.$el
  return instance.vm
}

export default Evt_rule_Dialog